import { Input } from '@/components'
import { Subtitle } from '../../Cena.styles'
import { GridInputContainer, ImprensaInputContainer } from '../Imprensa/Imprensa.styles'
import { useCenaContext } from '../../Cena.context'

export function Favorability() {
  const { favorabilidade, updateFavorabilidade } = useCenaContext()

  const handleFieldChange = (field: string, value: string) => {
    updateFavorabilidade({ [field]: value })
  }

  return (
    <>
      <Subtitle>Mensuração de favorabilidade</Subtitle>
      <GridInputContainer>
        <ImprensaInputContainer>
          <Input
            label="Positivo"
            type="number"
            placeholder="Peso"
            value={favorabilidade.positive}
            onChange={(value) => handleFieldChange('positive', value)}
          />
        </ImprensaInputContainer>
        <ImprensaInputContainer>
          <Input
            label="Favorável"
            type="number"
            placeholder="Peso"
            value={favorabilidade.favorable}
            onChange={(value) => handleFieldChange('favorable', value)}
          />
        </ImprensaInputContainer>
        <ImprensaInputContainer>
          <Input
            label="Desfavorável"
            type="number"
            placeholder="Peso"
            value={favorabilidade.unfavorable}
            onChange={(value) => handleFieldChange('unfavorable', value)}
          />
        </ImprensaInputContainer>
        <ImprensaInputContainer>
          <Input
            label="Negativo"
            type="number"
            placeholder="Peso"
            value={favorabilidade.negative}
            onChange={(value) => handleFieldChange('negative', value)}
          />
        </ImprensaInputContainer>
      </GridInputContainer>
    </>
  )
}
